const postFrequencyStr = {
  toastr: 'Periodicidad agregada',
  toastr1: 'fue agregada con éxito',
  toastrError: 'Periodicidad ya registrada',
  toastrError1: 'Ingrese otro nombre'
};

export default postFrequencyStr;
